import type { PropertySelectionRow } from "../../../types";

/**
 * 指定されたIDの行のタグを更新する
 * @param properties 更新対象のプロパティ配列
 * @param targetId 更新対象の行ID
 * @param newTags 新しいタグ配列
 * @returns 更新されたプロパティ配列
 */
export const updatePropertyTags = (
  properties: PropertySelectionRow[],
  targetId: number,
  newTags: string[]
): PropertySelectionRow[] => {
  return properties.map((row) =>
    row.id === targetId ? { ...row, tags: newTags } : row
  );
};
